import { Toast } from "../../components/notify/Notify";
import { getLocalAccessToken } from "../../utils/helper";
import api, { handleErrorShowCache } from "../../services/api";
import { url } from "../../constants/path";
const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.adbProvince;

export const getListProvince = (callback) => {
  api
    .get(URL)
    .then((response) => {
      callback(response.data.data);
    })
    .catch((err) => Toast("warning", err.response.data.message));
};

export const createProvince = (data, callback) => {
  api
    .post(URL, data)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const updateProvince = (id, data, callback) => {
  api
    .patch(`${URL}/${id}`, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const removeProvince = (id, callback) => {
  api
    .delete(`${URL}/${id}`)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getCacheProvince = (callback) => {
  api
    .get(`${URL}/cache`)
    .then((response) => {
      callback(response.data.data);
    })
    .catch((err) => {
      handleErrorShowCache(err);
    });
};

export const deployCacheProvince = (callback) => {
  api
    .post(`${URL}/deploy-cache`)
    .then((response) => {
      Toast("success", "Thành công");
      callback(response);
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};
